// Cosine Similarity Utility for Chatbot
export const SIMILARITY_THRESHOLD = 0.3;

// Simple cosine similarity calculation
function cosineSimilarity(vec1, vec2) {
  const dotProduct = vec1.reduce((sum, val, i) => sum + val * vec2[i], 0);
  const magnitude1 = Math.sqrt(vec1.reduce((sum, val) => sum + val * val, 0));
  const magnitude2 = Math.sqrt(vec2.reduce((sum, val) => sum + val * val, 0));
  return magnitude1 * magnitude2 === 0 ? 0 : dotProduct / (magnitude1 * magnitude2);
}

// Convert text to vector (simple word frequency)
function textToVector(text) {
  const words = text.toLowerCase().match(/\b\w+\b/g) || [];
  const vector = {};
  words.forEach(word => {
    vector[word] = (vector[word] || 0) + 1;
  });
  return vector;
}

// Get best match from knowledge base
export async function getBestMatch(query) {
  // This is a simplified version - in production, you'd have a knowledge base in Firestore
  // For now, we'll return a default response
  const responses = [
    "I can help you with questions about Aalay services, warranties, AMC schedules, and more.",
    "Please provide more details about what you're looking for.",
    "I'm here to assist you with your queries about our platform.",
  ];
  
  const randomResponse = responses[Math.floor(Math.random() * responses.length)];
  
  return {
    response: randomResponse,
    score: 0.5 // Default score
  };
}
